/* eslint-disable react/no-multi-comp */
import React, { PureComponent } from 'react';
import Form from '@atlaskit/form/Form';
import Drawer from '@atlaskit/drawer';
import {
	CustomDrawerWrapper,
	CustomDrawerContentWrapper,
	FooterKeyline,
} from './TemplateVariableInputStyles';

type CustomFullPageDrawerProps = {
	hasForm?: boolean;
	Content?: any;
	Body?: any;
	Title?: any;
	Footer?: any;
	isOpen: boolean;
	Icon?: any;
	onSubmit?: (data: any) => Promise<boolean>;
	isLoading: boolean;
	isFullWidth: boolean;
};

const CustomDrawerContentFormWrapper = (props: any) => {
	const { hasForm, onSubmit } = props;

	return hasForm && typeof onSubmit === 'function' ? (
		<Form onSubmit={onSubmit}>
			{({ formProps }) => (
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				<form {...formProps} name="text-fields" style={{ height: '100%' }}>
					{props.children}
				</form>
			)}
		</Form>
	) : (
		props.children
	);
};

// need this to be class so I can mount unmount window scroll listener
export class CustomFullPageDrawer extends PureComponent<CustomFullPageDrawerProps> {
	drawerScrollRef: React.RefObject<HTMLDivElement>;

	constructor(props) {
		super(props);
		this.drawerScrollRef = React.createRef();
	}

	componentDidMount() {
		// atlaskit/drawer's body has it's own scroll and the content underneath has scroll
		// so there is a double scroll in fullpage view
		document.body.style.overflow = 'hidden';
	}

	componentDidUpdate(): void {
		// atlaskit/drawer's body has it's own scroll and the content underneath has scroll
		// so there is a double scroll in fullpage view
		// when it updates it adds the scroll back so gotta remove it again ;_;
		document.body.style.overflow = 'hidden';
	}

	// restore scroll to the main content body
	componentWillUnmount() {
		document.body.style.overflow = '';
	}

	_submit = async (data) => {
		const { onSubmit } = this.props;
		if (onSubmit) {
			await onSubmit(data);
		}
	};

	render() {
		const { Content, Footer, hasForm, isOpen, Icon, Body, Title, isLoading, isFullWidth } =
			this.props;

		return (
			<Drawer isOpen={isOpen} width="full" icon={Icon} shouldUnmountOnExit>
				<CustomDrawerContentFormWrapper hasForm={hasForm} onSubmit={this._submit}>
					<CustomDrawerWrapper>
						<CustomDrawerContentWrapper>
							<Content
								ref={this.drawerScrollRef}
								Title={Title}
								Body={Body}
								isFullWidth={isFullWidth}
							/>
						</CustomDrawerContentWrapper>
						<FooterKeyline>
							<Footer isLoading={isLoading} isFullWidth={isFullWidth} />
						</FooterKeyline>
					</CustomDrawerWrapper>
				</CustomDrawerContentFormWrapper>
			</Drawer>
		);
	}
}
